import { type, Entity, validatedResource, association, resource, repository } from 'aurelia-orm';
import { ValidationRules } from 'aurelia-validation';
import { autoinject } from 'aurelia-framework';
import { validateCompare } from "../customRules/compareValidation";


@resource('notificationinfo')
export class NotificationInfo extends Entity {
	id: number;
	itemId: number;
	historyTypeId: number;
	inserted: Date;
	columnName: string;
	originalValue: string;
	newValue: string;
	tenantId: number;
	appUserId: number;
	content: string;
	seen: boolean;
	showDetails: boolean;
	children: Array<NotificationInfo>;
}